import './App.css';
import AdminGalleryPage from "./Pages/Dashboard/admin_courses"
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import HomePage from './Pages/Home/HomePage';
import AboutUs from './Pages/AboutUs/AboutUs';
import AdminStudents from './Pages/Dashboard/admin_students';
import AdminCourses from './Pages/Dashboard/admin_courses';
import AdminJobs from './Pages/Dashboard/adminJobs';
import AdminHome from './Pages/Dashboard/admin_home';
import LastpageSocial from './Pages/Last page/Lastpage-Social';
import LoginRegister from "../src/Components/Login page/LoginForStudent";
import AdminLoginRegister from "../src/Components/Login page/LoginForAdmin";
import Gallery from "../src/Pages/AchivementGallery/AchievementGalleryPage";

import StudentPage from "./Pages/StudentPage/StudentDashboard";
import CareerPage from "./Pages/StudentPage/CareerPage";
import FloatingContactButtons from "./Components/LAST Page/FloatingContactButtons";
import CoursesPage from "./Pages/CoursesPage";
const isAdminAuthenticated = () => Boolean(localStorage.getItem('adminToken'));

const AdminProtectedRoute = ({ children }) => {
  return isAdminAuthenticated() ? children : <Navigate to="/admin-login" replace />;
};

const StudentProtectedRoute = ({ children }) => {
  return localStorage.getItem("token") ? children : <Navigate to="/login" replace />;
};

function PublicFloatingContactButtons() {
  const { pathname } = useLocation();
  const publicPaths = new Set(["/", "/about", "/lastpage", "/gallery", "/career", "/courses", "/jobs"]);

  return publicPaths.has(pathname) ? <FloatingContactButtons /> : null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
    
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/admin" element={<AdminProtectedRoute><AdminHome /></AdminProtectedRoute>} />
          <Route path="/dashboard" element={<AdminProtectedRoute><AdminHome /></AdminProtectedRoute>} />
          <Route path="/students" element={<AdminProtectedRoute><AdminStudents /></AdminProtectedRoute>} />
          <Route path="/admin/courses" element={<AdminProtectedRoute><AdminCourses /></AdminProtectedRoute>} />
          <Route path="/lastpage" element={<LastpageSocial />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="*" element={<Navigate to="/" replace />} />
            {/* Authentication */}
  <Route path="/login" element={<LoginRegister />} />
  <Route path="/register" element={<LoginRegister />} />
  <Route 
    path="/admin-login" 
    element={<AdminLoginRegister />} 
/>
<Route
  path="/student-dashboard"
  element={
<StudentProtectedRoute><StudentPage /></StudentProtectedRoute>
  }
/>
<Route path="/career" element={<CareerPage />} />
<Route path="/jobs" element={<AdminJobs />} />
<Route
  path="/admin-gallery"
  element={
    <AdminProtectedRoute>
      <AdminGalleryPage />
    </AdminProtectedRoute>
  }
/>
        </Routes>
        <PublicFloatingContactButtons />
      </div>
    </BrowserRouter>
  );
}

export default App;
